import { apiClient } from '../../../services/authApi';
import {
  VIPMember,
  VIPStatistics,
  VIPMemberCreateData,
  VIPMemberUpdateData,
} from '../models/VIPMember';

/**
 * VIP 회원 관리 리포지토리
 */
export class VIPMemberRepository {
  /**
   * VIP 회원 목록 조회
   */
  async getMembers(): Promise<VIPMember[]> {
    try {
      const response = await apiClient.get('/v1/vip/members');
      return response.data;
    } catch (error) {
      console.error('VIP 회원 로드 실패:', error);
      throw error;
    }
  }

  /**
   * VIP 통계 조회
   */
  async getStatistics(): Promise<VIPStatistics> {
    try {
      const response = await apiClient.get('/v1/vip/statistics');
      return response.data;
    } catch (error) {
      console.error('VIP 통계 로드 실패:', error);
      throw error;
    }
  }

  /**
   * VIP 회원 추가
   */
  async createMember(data: VIPMemberCreateData): Promise<VIPMember> {
    try {
      const response = await apiClient.post('/v1/vip/members', data);
      return response.data;
    } catch (error) {
      console.error('VIP 회원 추가 실패:', error);
      throw error;
    }
  }

  /**
   * VIP 회원 정보 수정
   */
  async updateMember(
    memberId: string,
    data: VIPMemberUpdateData
  ): Promise<VIPMember> {
    try {
      const response = await apiClient.put(`/v1/vip/members/${memberId}`, data);
      return response.data;
    } catch (error) {
      console.error('VIP 회원 수정 실패:', error);
      throw error;
    }
  }

  /**
   * VIP 회원 비활성화 (삭제)
   */
  async deleteMember(memberId: string): Promise<void> {
    try {
      await apiClient.delete(`/v1/vip/members/${memberId}`);
    } catch (error) {
      console.error('VIP 회원 삭제 실패:', error);
      throw error;
    }
  }
}

export const vipMemberRepository = new VIPMemberRepository();
